import Base, { baseInit } from './base';

export class ProductCategoryDeviceAllocation extends Base {
  id = null; // Integer
  deviceType = null; // String
  budgetPercentage = null; // Integer
  budget = null; // Integer
  impressions = null; // Integer

  constructor(data) {
    super(data);
    baseInit(this, data);
  }
}
